const option = [
    { id: 1, name: 'อยู่ระหว่างดำเนินการ' },
    { id: 2, name: 'ปิดงาน' }
]

export default {
    option: option
};